import jQuery from 'jquery';

(function($) {
    $(function() {
        // Add a new project
        $('body').on('click', '.add-project', function() {
            $('.projects')
                .first()
                .clone()
                .find('input, textarea')
                .val('')
                .end()
                .insertAfter($('.projects').last());
        });

        // Remove a project
        $('body').on('click', '.remove-project', function() {
            $(this).closest('.projects').remove();
        });
    });
})(jQuery);
